<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Verify Citizen ID</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <CCol>
              <CDataTable :items="items" :fields="fields" column-filter>
                <template #userid="{item}">
                  <td>
                    <div style="font-weight: bold">{{item.userid}}</div>
                  </td>
                </template>
                <template #name="{item}">
                  <td>
                    <div style="font-weight: bold">{{item.name}}</div>
                  </td>
                </template>
                <template #verified="{item}">
                  <td class="d-flex flex-row align-items-center">
                    <c-icon
                      name="cibDiscover"
                      class="icon-space"
                      :style="getVerifedColor(item.verified)"
                    />
                    <div style="font-weight: bold">{{(item.verified).toUpperCase()}}</div>
                  </td>
                </template>
                <template #action>
                  <td>
                    <div class="action">
                      <div @click="setIsProfileModalShow()">
                        <img src="@/assets/images/admin/Role Management.svg" class="action-icon icon" />
                      </div>
                      <div>
                        <img src="@/assets/images/admin/Profile Icon.svg" class="action-icon icon" />
                      </div>
                      <div>
                        <img src="@/assets/images/admin/Mail.svg" class="action-icon icon" />
                      </div>
                    </div>
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
    <ProfileInfo :modalVisible="isProfileModalShow" :setModalVisible="setIsProfileModalShow" />
  </CContainer>
</template>

<script>
import ProfileInfo from "../modal/ProfileInfo";

const items = [
  {
    num: "00",
    userid: "000000",
    name: "fullname",
    email: "useremail",
    verified: "Approved",
    status: "active",
    role: ["user", "owner", "admin"]
  },
  {
    num: "00",
    userid: "000000",
    name: "fullname",
    email: "useremail",
    verified: "Pending",
    status: "off",
    role: ["user", "owner", "admin"]
  },
  {
    num: "00",
    userid: "000000",
    name: "fullname",
    email: "useremail",
    verified: "No Verify",
    status: "active",
    role: ["user", "owner", "admin"]
  }
];

const fields = [
  { key: "num", label: "NUM", filter: false },
  { key: "userid", label: "USER ID" },
  { key: "name", label: "NAME" },
  { key: "email", label: "E-MAIL" },
  { key: "verified", label: "VERIFIED" },
  { key: "action", label: "ACTION", filter: false }
];

export default {
  name: "verifyCitizenID",
  components: {
    ProfileInfo
  },
  data() {
    return {
      isProfileModalShow: false,
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      fields
    };
  },
  methods: {
    getVerifedColor(status) {
      switch (status) {
        case "Approved":
          return "color: #0BB190";
        case "Pending":
          return "color: #F2DE79";
        case "No Verify":
          return "color: #F27979";
      }
    },
    setIsProfileModalShow() {
      this.isProfileModalShow = !this.isProfileModalShow;
    }
  }
};
</script>
